import React, {useState, useEffect, useRef} from 'react';
import {IoChevronForward} from "react-icons/io5";
import './SlideToDelete.css';

const SlideToDelete = ({onConfirm, onCancel}) => {
    const [handlePosition, setHandlePosition] = useState(0);
    const [isDragging, setIsDragging] = useState(false);
    const sliderRef = useRef(null);
    const handleRef = useRef(null);
    
    const handleDragStart = () => {
        setIsDragging(true);
    };
    
    const handleDragEnd = React.useCallback(() => {
        setIsDragging(false);
        if (sliderRef.current && handleRef.current && handlePosition < (sliderRef.current.clientWidth - handleRef.current.clientWidth - 5)) {
            setHandlePosition(0);
        }
    }, [handlePosition]);
    
    const handleDragMove = React.useCallback((clientX) => {
        if (!isDragging || !sliderRef.current || !handleRef.current) return;
        const sliderRect = sliderRef.current.getBoundingClientRect();
        const handleWidth = handleRef.current.clientWidth;
        const maxPosition = sliderRect.width - handleWidth;
        let newX = clientX - sliderRect.left - (handleWidth / 2);
        if (newX < 0) newX = 0;
        if (newX > maxPosition) newX = maxPosition;
        setHandlePosition(newX);
        if (newX >= maxPosition - 5) {
            onConfirm();
            setIsDragging(false);
        }
    }, [isDragging, onConfirm]);
    
    useEffect(() => {
        const handleMouseMove = (e) => handleDragMove(e.clientX);
        const handleMouseUp = () => handleDragEnd();
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
        }
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, handleDragMove, handleDragEnd]);
    
    useEffect(() => {
        const handleTouchMove = (e) => handleDragMove(e.touches[0].clientX);
        const handleTouchEnd = () => handleDragEnd();
        if (isDragging) {
            window.addEventListener('touchmove', handleTouchMove);
            window.addEventListener('touchend', handleTouchEnd);
        }
        return () => {
            window.removeEventListener('touchmove', handleTouchMove);
            window.removeEventListener('touchend', handleTouchEnd);
        };
    }, [isDragging, handleDragMove, handleDragEnd]);
    
    return (
        <div className="confirmation-actions">
            <button onClick={onCancel} className="btn-cancel">Cancel</button>
            <div className="slide-to-delete-container" ref={sliderRef}>
                <div 
                    className="slider-handle" 
                    ref={handleRef} 
                    style={{left: `${handlePosition}px`}} 
                    onMouseDown={handleDragStart} 
                    onTouchStart={handleDragStart}
                >
                    <IoChevronForward size="1.5em" />
                    <IoChevronForward size="1.5em" style={{marginLeft: '-12px'}} />
                </div>
                <span className="slider-text">Slide to Confirm Deletion</span>
            </div>
        </div>
    );
};

export default SlideToDelete; 